import { round } from 'lodash';
import * as getters from '../../store/getters';
import FormatMixin from '../../../../../Application/mixins/FormatMixin';

const { valorReal } = FormatMixin.methods;

const taxInformationForEditFromXml = (taxInformation) => {
  const { entryDate, issueDate, nfe } = taxInformation;

  return {
    ...taxInformation,
    ...nfe,
    issueDate: new Date(issueDate),
    entryDate: new Date(entryDate),
  };
};

const supplierForEditFromXml = (supplier) => ({
  supplier: {
    ...supplier,
    supplierId: supplier.id,
    address: supplier.address ?? getters.getDefaultAddressState(),
    phone: {
      number: supplier?.phone?.number ?? '',
    },
  },
});

const transportForEditFromXml = (transport) => {
  const weightDecimalConfiguration = 3;
  return {
    ...transport,
    shippingCompany: transport?.shippingCompany ?? {},
    volume: {
      ...transport?.volume,
      grossWeight:
        valorReal(
          round(
            transport?.volume?.grossWeight,
            weightDecimalConfiguration,
          ),
          weightDecimalConfiguration,
        ),
      netWeight:
        valorReal(
          round(
            transport?.volume?.netWeight,
            weightDecimalConfiguration,
          ),
          weightDecimalConfiguration,
        ),
    },
    freight: transport?.freight ? { ...transport.freight } : null,
  };
};

export const paymentForEditFromXml = (payments) => {
  const { paymentModeCollection } = payments;
  const stdPaymentModeCollection = paymentModeCollection.map((payment) => {
    let stdPayment = {
      ...payment,
      id: undefined,
      paymentModeId: payment.id,
    };
    if (!payment.value) {
      stdPayment = {
        ...stdPayment,
        value: 0,
      };
    }
    return stdPayment;
  });

  return {
    paymentModeCollection: stdPaymentModeCollection,
  };
};

export const stdObjectForEditFromXml = async (serializedXml) => ({
  ...serializedXml,
  taxInformation: taxInformationForEditFromXml(serializedXml.taxInformation),
  supplierInformation: supplierForEditFromXml(serializedXml.supplier),
  transport: transportForEditFromXml(serializedXml.transport),
  payments: paymentForEditFromXml(serializedXml.payments),
});
